export default __webpack_public_path__ + "static/media/pet.543b0075.jpg";